import { isObjectDeeplyChanged } from '../../util/state';
import { State } from './index';

export const getUpdateFlags = (state: State, oldState: State) => {
    const { tariffs, avcResult, selected } = state;
    const selectedChanged = selected.tariff && selected.tariffId !== oldState.selected.tariffId;
    const tariffsChanged = tariffs && tariffs !== oldState.tariffs;
    const avcResultChanged = isObjectDeeplyChanged(avcResult, oldState.avcResult);

    return {
        selectedChanged: selectedChanged,
        tariffChanged: tariffsChanged || selectedChanged || avcResultChanged,
    };
};
